import React from 'react';
import { GraduationCap, MapPin, Calendar } from 'lucide-react';
import { education } from '../data/mock';

const Education = () => {
  return (
    <section className="py-24 bg-black relative">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <span className="text-gray-500 text-sm font-mono tracking-wider uppercase">Academic Background</span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6">
              Education
            </h2>
            <div className="w-20 h-1 bg-white mx-auto"></div>
          </div>

          {/* Education Timeline */}
          <div className="space-y-8">
            {education.map((edu) => (
              <div
                key={edu.id}
                className="bg-gray-950 border border-gray-800 rounded-xl p-8 hover:border-gray-700 transition-all duration-300"
              >
                <div className="flex items-start gap-6">
                  {/* Icon */}
                  <div className="bg-white w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0">
                    <GraduationCap className="w-7 h-7 text-black" />
                  </div>

                  {/* Content */}
                  <div className="flex-1">
                    <div className="flex items-start justify-between flex-wrap gap-4 mb-3">
                      <div>
                        <h3 className="text-2xl font-bold text-white mb-1">{edu.degree}</h3>
                        <p className="text-gray-400 text-lg">{edu.field}</p>
                      </div>
                      {edu.type === 'master' && (
                        <span className="px-3 py-1 bg-white text-black text-xs font-semibold rounded-full">
                          MASTER'S
                        </span>
                      )}
                      {edu.type === 'exchange' && (
                        <span className="px-3 py-1 bg-gray-800 text-white text-xs font-semibold rounded-full">
                          ERASMUS+
                        </span>
                      )}
                    </div>

                    <div className="flex items-center gap-6 text-gray-500 text-sm flex-wrap">
                      <div className="flex items-center gap-2">
                        <MapPin className="w-4 h-4" />
                        <span>{edu.institution}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <Calendar className="w-4 h-4" />
                        <span>{edu.period}</span>
                      </div>
                      {edu.location && (
                        <span className="text-gray-600">• {edu.location}</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
